import { render } from "./SearchBarFilters.vue?vue&type=template&id=057edf0c&scoped=true"
import script from "./SearchBarFilters.vue?vue&type=script&lang=js"
export * from "./SearchBarFilters.vue?vue&type=script&lang=js"

import "./SearchBarFilters.vue?vue&type=style&index=0&id=057edf0c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057edf0c"]])

export default __exports__